export default "__VITE_ASSET__o$GGkT9j__"